import { Component, computed, inject, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { EDeliverableType, EPlatformFeature } from '@enums/campaign.enum';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '@shared/components/icon/icon.component';
import { DeliverableAdvancedSettingsService } from '../deliverable-advanced-settings.service';

@Component({
  imports: [IconComponent, TranslateModule, MatButtonModule],
  selector: 'app-deliverable-advanced-button',
  templateUrl: './deliverable-advanced-button.component.html',
})
export class DeliverableAdvancedButtonComponent {
  public readonly platformFeature = input<EPlatformFeature | null | undefined>(null);
  public readonly deliverableType = input.required<EDeliverableType>();
  public readonly isOpen = input<boolean>(false);

  public readonly toggled = output<void>();

  private readonly advancedSettingsService = inject(DeliverableAdvancedSettingsService);

  public readonly isVisible = computed(() =>
    this.advancedSettingsService.hasAnyAdvancedSettings(this.platformFeature(), this.deliverableType()),
  );

  public onToggle(event: Event): void {
    event.stopPropagation();
    this.toggled.emit();
  }
}
